type SanityAssets = {
  current: Record<string, any>;
};

// TODO rework this once we consolidate BK + Frontend
export const sanityAssets: SanityAssets = { current: {} };
